/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum ElementsPerPage {
  TEN = 10,
  TWENTY = 20,
  TWENTY_FIVE = 25,
  FIFTY = 50,
  HUNDRED = 100,
}
export const PAGINATION_SIZES = [
  { label: '10', value: ElementsPerPage.TEN, active: 'false' },
  { label: '20', value: ElementsPerPage.TWENTY, active: 'false' },
  { label: '50', value: ElementsPerPage.FIFTY, active: 'false' },
  { label: '100', value: ElementsPerPage.HUNDRED, active: 'false' },
];

export const PAGINATION_SIZES_25 = [
  { label: '25', value: ElementsPerPage.TWENTY_FIVE, active: 'false' },
  { label: '50', value: ElementsPerPage.FIFTY, active: 'false' },
  { label: '100', value: ElementsPerPage.HUNDRED, active: 'false' },
];
